import { render, staticRenderFns } from "./medicalSearch.vue?vue&type=template&id=8f0a07e4&scoped=true"
import script from "./medicalSearch.vue?vue&type=script&lang=js"
export * from "./medicalSearch.vue?vue&type=script&lang=js"
import style0 from "./medicalSearch.vue?vue&type=style&index=0&id=8f0a07e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0a07e4",
  null
  
)

export default component.exports